import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Spin, Card, Typography } from 'antd'
import { useAuth } from './AuthContext'
import { LoadingOutlined } from '@ant-design/icons'

const { Title, Paragraph } = Typography

const ProtectedRoute = ({ children, requiresAuth = true }) => {
  const { isAuthenticated, loading, user } = useAuth()
  const location = useLocation()

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className='min-h-screen flex items-center justify-center bg-gray-50'>
        <Card className='text-center p-8'>
          <Spin
            size='large'
            indicator={
              <LoadingOutlined style={{ fontSize: 48, color: '#dc2626' }} />
            }
          />
          <Title level={3} className='mt-4 text-gray-700'>
            Verifying Authentication...
          </Title>
          <Paragraph className='text-gray-500'>
            Please wait while we verify your dealer credentials
          </Paragraph>
        </Card>
      </div>
    )
  }

  // If authentication is required but user is not authenticated
  if (requiresAuth && !isAuthenticated) {
    // Redirect to login with the current location as state
    return <Navigate to='/login' state={{ from: location }} replace />
  }

  // If user is authenticated but accessing login page, redirect to warranty registration
  if (!requiresAuth && isAuthenticated && location.pathname === '/login') {
    return <Navigate to='/alloy-registration' replace />
  }

  // User is authenticated and accessing a protected route, or doesn't need auth
  return children
}

export default ProtectedRoute
